import {ChangeDetectorRef, Component, ContentChild, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractVisbosControl} from "../abstract-visbos-control";
import {FormArray, FormBuilder} from "@angular/forms";
import {IModel} from "../../../../../shared/view-model/imodel.interface";
import {AutoComplete} from "primeng/primeng";
import {SessionActions} from "../../../../../shared/actions";
import {KeywordService} from "../../../services/keyword.service";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";

@Component({
    selector: 'vb-multi-select-typeahead',
    templateUrl: './multi-select-typeahead.component.html',
    styleUrls: ['./multi-select-typeahead.component.css']
})
export class MultiSelectTypeaheadComponent<T extends IModel> extends AbstractVisbosControl<T, FormArray> implements OnInit {

    @ViewChild('inputField')
    inputField: AutoComplete;

    @Input()
    searchFunction: (searchString: string, itemList: T[]) => T[];

    @ContentChild(TemplateRef) vbTemplate: TemplateRef<any>;

    @Input()
    placeholder: string = "Tippen für Autovervollständigung...";

    @Input()
    dropdown: boolean = false;

    @Input()
    valueField: string = 'label';

    private _items: T[];

    @Input()
    set items(items: T[]) {
        this._items = items;
        this.patchItemsValues();
    }

    get items(): T[] {
        return this._items;
    }

    @Input()
    data: Observable<any>;

    searchLoading: boolean = false;

    searchText: string;
    private searchToken$: Subject<string> = new Subject();

    suggestions: T[] = [];


    constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
                private keywordService: KeywordService) {
        super(fb, cd, sessionActions);
    }

    patchItemsValues() {

        if (!this.control) {
            return;
        }

        this.control.controls = [];
        this.control.reset();

        if (!this.items) {
            return;
        }

        for (let item of this.items) {
            this.control.push(this.fb.control(item[this.valueField]));
        }

    }

    ngOnInit() {
        super.ngOnInit();

        this.data = this.keywordService.findKeywords(this.searchToken$);
        this.dataSubscriptions.push(this.data.subscribe(res => {
            this.searchLoading = res.loading;
            this.suggestions = res.data.keywords;
        }));

    }

    onSelect(selectedItem: T) {
        this.addItemToList(selectedItem[this.valueField]);
    }

    onNew(event: KeyboardEvent) {
        if (event.key == 'Enter') {
            this.addItemToList(this.searchText);
        }
    }

    buildControlContent(): FormArray {
        return MultiSelectTypeaheadComponent.initControl(this.fb);
    }

    public static initControl(fb: FormBuilder): FormArray {
        return fb.array([]);
    }

    search(event) {

        if (!event || !event.query || event.query == '') {
            this.searchLoading = false;
            return;
        }

        this.searchToken$.next(event.query);

    }

    addItemToList(value: string) {
        if (value) {
            this.control.push(this.fb.control(value));
        }
        this.searchText = null;
    }

    deleteItemFromList(index: number) {
        this.control.removeAt(index);
    }

    focus() {
        this.inputField.el.nativeElement.children[0].children[0].focus();
    }

    handleDropdown(event) {
        console.error("Not yet implemented!");
    }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/multi-select-typeahead/multi-select-typeahead.component.ts